import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import IITLogo from '../image/IITLogo.png';
import { Link } from 'react-router-dom';



export default function Header() {
  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary" fixed='top' style={{ borderBottom: "1px solid #ddd" }}>
        <Container>
          <Navbar.Brand href={`${process.env.PUBLIC_URL}/`}><img src={IITLogo} height={'40pxs'} /> Dr V M Chariar</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">

              <NavDropdown title="Research" id="basic-nav-dropdown">
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/research/overview`}>Overview</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/research/traditional`}>Traditional Knowledge</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/research/sustainability`}>Design for Sustainability</NavDropdown.Item>
                <NavDropdown.Item href="https://www.joyisyou.com/" target='_blank'>Joyous Self Discovery <i className="bi bi-box-arrow-up-right"></i></NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/research/publications`}>Published Work</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Co-Learning" id="basic-nav-dropdown">
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/overview`}>Overview</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/traditionalknowledge`}>Traditional Knowledge & Values</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/artisanalproduction`}>Traditional Artisanal Production in India</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/dti`}>Design Thinking & Innovation</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/entrepreneurship`}>Rural innovation & Entreprenuership</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/rdtalternative`}>Rural Dev. & Technology Alternatives</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/colearning/lifeskills`}>Life Skills</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Frugal Innovation JoyLab" id="basic-nav-dropdown">
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/joylab/overview`}>Overview</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/joylab/blog`}>Joylab Blog</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Events" id="basic-nav-dropdown">
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/possibilitiesDialogue`}>Frugal Possibilities Dialogue</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/educarnival25`}>Educarnival 2025</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/sparccourse`}>SPARC Course</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/sparcsyposium`}>SPARC Symposium</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/eitecent`}>e-ITEC Entreprenuership</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/eitechealth`}>e-ITEC Healthcare</NavDropdown.Item>
                <NavDropdown.Item href={`${process.env.PUBLIC_URL}/events/cipra`}>CIPRA 2020</NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href={`${process.env.PUBLIC_URL}/about`}>About</Nav.Link>
              {/*<Nav.Link as={Link} href="/contact">Contact</Nav.Link>*/}

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div style={{ marginBottom: "67px" }}></div>
    </>
  )
}